/** The link a QR code hands to a phone (items 0324 and Share).
 *
 *  Built from an ALLOWLIST, never by copying the current URL. The totem's own
 *  URL carries provisioning that must not follow the visitor home:
 *    - ?kiosk=     makes the viewer behave as a totem: idle reset, the menu can
 *                  never collapse, the map turns to the wall's heading
 *    - ?lowpower=  a weak SoC's setting, wrong for a modern phone
 *    - ?ui=0, ?route_style= / ?route_color= / ?route_occluded= previews
 *  Anything not written below is dropped, so a parameter added to the viewer
 *  later cannot leak into the phone link by accident.
 *
 *  What the phone needs to continue where the totem was:
 *    lang   the language the visitor chose on the totem
 *    to     the POI on screen
 *    from   the totem the visitor is standing at -- the ROUTE ORIGIN. It is
 *           deliberately not ?kiosk=: the phone is not a totem, it only needs
 *           to know where "here" was.
 *    route  "1" when directions were on screen: the phone draws them on load.
 */
export function viewerLink({ venueSlug, lang, poiSlug, fromKiosk, route = false }) {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  const url = new URL(`${window.location.origin}${base}/id/${encodeURIComponent(venueSlug)}`);
  if (lang) url.searchParams.set("lang", lang);
  if (poiSlug) url.searchParams.set("to", poiSlug);
  if (fromKiosk) url.searchParams.set("from", fromKiosk);
  if (route && poiSlug && fromKiosk) url.searchParams.set("route", "1");
  return url.toString();
}
